import {
  PAGE_TYPE_BOOKING_PANEL_INDICATIVE_PRICES,
  PAGE_TYPE_UNSPECIFIED,
} from '@web-platform/shared-universal-constants/src/michelin';
import { QUERY_RESPONSE_RECEIVED } from '@web-platform/shared-universal-constants/src/network';
import { MICHELIN_GET_HOTEL_CARHIRE_CREATE_SEARCH } from '@web-platform/shared-universal-types/src/network/requestTypes';

import { USER_REQUESTED_SEARCH } from '../../../../actions/searchControls';

import type { SkyscannerMichelinSearchV1Search } from '@skyscanner-internal/michelin-web-http-client';
import type { Action } from '@web-platform/shared-universal-types/src/redux/banana/actions/actions-banana-types';
import type {
  Vertical,
  VerticalsState,
} from '@web-platform/shared-universal-types/src/redux/banana/state/shared/michelin/verticals';

type SearchResponse = SkyscannerMichelinSearchV1Search.SearchResponse;

export const INITIAL_STATE: VerticalsState = [];

const transformVerticalsData = (
  response: SearchResponse,
  state: VerticalsState,
): VerticalsState => {
  if (!response?.verticals || response.verticals.length === 0) {
    return state;
  }

  const validVerticals = response.verticals.filter(
    (vertical): vertical is Vertical => vertical === 'carhire' || vertical === 'hotels',
  );

  return validVerticals;
};

export default (state: VerticalsState = INITIAL_STATE, action: Action): VerticalsState => {
  switch (action.type) {
    case QUERY_RESPONSE_RECEIVED: {
      const { payload } = action;

      if (
        payload.type === MICHELIN_GET_HOTEL_CARHIRE_CREATE_SEARCH &&
        payload.response?.body &&
        typeof payload.response.body === 'object' &&
        'verticals' in payload.response.body &&
        (payload.variables?.pageType === PAGE_TYPE_UNSPECIFIED ||
          payload.variables?.pageType === PAGE_TYPE_BOOKING_PANEL_INDICATIVE_PRICES)
      ) {
        return transformVerticalsData(payload.response.body, state);
      }

      return state;
    }

    case USER_REQUESTED_SEARCH: {
      const { payload } = action;
      if (payload.searched) {
        return INITIAL_STATE;
      }
      return state;
    }

    default:
      return state;
  }
};

export const get = (state: VerticalsState): VerticalsState => state;
